import { Colors } from '@src/colors';
import styled from 'styled-components';

export const Button = styled.button`
    font-family: 'Public Sans';
    background: ${Colors.ownerYellow};
`;

export const LinkButton = styled.a<{ color: 'white' | 'yellow' }>`
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    gap: 10px;

    font-family: 'Public Sans';
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 0px;

    cursor: default;

    > span {
        white-space: nowrap;
        color: ${(props) => (props.color === 'white' ? Colors.white : Colors.ownerYellow)};
    }
    > svg {
        g,
        path {
            fill: ${(props) => (props.color === 'white' ? Colors.white : Colors.ownerYellow)};
        }
    }

    &:hover,
    &:focus {
        > span {
            color: ${(props) =>
                props.color === 'white' ? Colors.duskTwenty : Colors.vacasaYorange};
        }
        > svg {
            g,
            path {
                fill: ${(props) =>
                    props.color === 'white' ? Colors.duskTwenty : Colors.vacasaYorange};
            }
        }
    }
`;
